'use client';

import { ThemeProvider } from '@react/chakra/core';
import { QueryClientProvider } from '@react/utils/queryHooks';

import type { JSX, ReactNode } from 'react';

import { theme } from '~/config/chakraTheme';
import { getQueryClient } from '~/utils/queryClient';

interface IProviderProps {
  children: ReactNode;
}

export function Provider({ children }: IProviderProps): JSX.Element {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </QueryClientProvider>
  );
}
